export function getLastChildElementRecursive(el: Node): Node {
	if (el.lastChild) {
		return getLastChildElementRecursive(el.lastChild);
	}

	return el;
}
